import React from "react";
import { MinusIcon, PlusIcon } from "@heroicons/react/solid";
import { ReserveFormAdminReservation } from "@/features/reserve/components/Reserve/views/ReserveFormAdminReservation";
import { useReserveForm } from "@/features/reserve/components/Reserve/ReserveFormProvider";

export const ReserveFormOtherUserReservation: React.FC = () => {
  const {
    allowOthers,
    setEnableAdminReservation,
    enableAdminReservation,
    owner
  } = useReserveForm();
  if (!allowOthers) return null;

  return (
    <div className="text-left">
      <div>
        <button
          type="button"
          onClick={(ev) => {
            ev.preventDefault();
            setEnableAdminReservation((x) => !x);
          }}
          className="flex items-center gap-1 pb-2 font-inter font-normal text-secondary text-sm leading-none tracking-normal pb-0 !text-neutral-1000 rounded-v2"
        >
          {!enableAdminReservation ? (
            <PlusIcon className="mr-1.5 h-6 w-4" />
          ) : (
            <MinusIcon className="mr-1.5 h-6 w-4" />
          )}
          Create Reservation for Another User
        </button>
        <ReserveFormAdminReservation />
      </div>
    </div>
  );
};
